'use strict';

const { isMobile } = require('../utilities/breakpoints');

function tabNavCountrySelector() {
    if (isMobile()) {
        const $dialogCountrySelector = $('.js-country-selector-pop');
        const $navItems = $dialogCountrySelector.find('.countries__nav li');
        const $contentItems = $dialogCountrySelector.find('.countries__content--item');

        $navItems.first().addClass('active');
        $contentItems.hide().first().show();
        
        $navItems.on('click', function (e) {
            e.preventDefault();
    
            const $this = $(this);
            const $countrys = $this.closest('.countries');
            const targetSelector = $this.find('a').attr('href');
            const $targetContent = $countrys.find('.countries__content').find(targetSelector);
    
            $navItems.removeClass('active');
            $this.addClass('active');
            $contentItems.hide();
            $targetContent.show();
        });
    }
}

module.exports = function () {
    tabNavCountrySelector();
};